import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import watermark from 'images/watermark.png';

export default class AssetThumbnail extends Component {
  static propTypes = {
    image: PropTypes.string.isRequired,
    watermarked: PropTypes.bool,
    className: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func
  };

  state = {
    image: null,
    loading: true
  };

  ref = React.createRef();

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.image !== this.props.image) {
      this.load();
    }
  }

  load = () => {
    const { image, className } = this.props;

    const isSmall = className.includes('small');

    const width = this.ref.current.offsetWidth;
    const height = this.ref.current.offsetHeight;

    this.setState({
      image: null,
      loading: true
    });

    let img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');

    img.onload = () => {
      const zoomModifier = img.width > img.height ? width / img.width : height / img.height;
      const retinaModifier = isSmall ? 3 : 2;
      const newWidth = img.width * (zoomModifier < 1 ? zoomModifier : 1) * retinaModifier;
      const newHeight = img.height * (zoomModifier < 1 ? zoomModifier : 1) * retinaModifier;
      const canvas = document.createElement('canvas');
      canvas.width = newWidth;
      canvas.height = newHeight;

      setTimeout(() => {
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        this.setState({
          image: canvas.toDataURL('image/png'),
          loading: false
        });
      }, 200);
    };

    img.onerror = () => {
      this.setState({ loading: false });
    };

    img.src = image;
  };

  render() {
    const { title, className, onClick, style, watermarked } = this.props;
    const { loading } = this.state;
    const image = this.state.image || this.props.image;
    return (
      <div
        ref={this.ref}
        className={classNames(className)}
        style={{
          backgroundImage: !loading ? `url(${image})` : '',
          ...style
        }}
        onClick={onClick}
        data-tip={title}
        title={title}
      >
        {!loading && watermarked && <div className="watermark" style={{ backgroundImage: `url("${watermark}")` }} />}
        {loading && (
          <div className="loader d-flex align-items-center justify-content-around">
            <i className="fas fa-spinner fa-spin" />
          </div>
        )}
      </div>
    );
  }
}
